import { Card, GKTextField, Grid2, Tab, Tabs } from "components";
import DashboardLayout from "layouts/DashboardLayout";
import { useState } from "react";
import { useForm } from "react-hook-form";
import useDocumentTitle from "utils/useDocumentTitle";

type FormValues = {
  portfolioName: string;
  billedRevenue: string;
  lastFeePlan: string;
  unBilledRevenue: string;
  lastFeeCollected: string;
  partner: string;
};

const EditRevenuePortfolio = () => {
  const [tab, setTab] = useState(0);

  useDocumentTitle("Revenue Portfolio Details");

  const form = useForm<FormValues>({
    defaultValues: {
      portfolioName: "",
      billedRevenue: "",
      lastFeePlan: "",
      unBilledRevenue: "",
      lastFeeCollected: "",
      partner: "",
    },
  });

  return (
    <DashboardLayout title={"Portfolios"}>
      <Card>
        <Grid2 container spacing={1} columnSpacing={2}>
          <Grid2 size={4}>
            <GKTextField
              inputLabel="Portfolio Name"
              name="portfolioName"
              onChange={(e) => form.setValue("portfolioName", e.target.value)}
            />
          </Grid2>
          <Grid2 size={4}>
            <GKTextField
              inputLabel="Billed Revenue"
              name="billedRevenue"
              onChange={(e) => form.setValue("billedRevenue", e.target.value)}
            />
          </Grid2>
          <Grid2 size={4}>
            <GKTextField
              inputLabel="Last Fee Plan"
              name="lastFeePlan"
              onChange={(e) => form.setValue("lastFeePlan", e.target.value)}
            />
          </Grid2>
          <Grid2 size={4}>
            <GKTextField
              inputLabel="unbilled Revenue"
              name="unBilledRevenue"
              onChange={(e) => form.setValue("unBilledRevenue", e.target.value)}
            />
          </Grid2>
          <Grid2 size={4}>
            <GKTextField
              inputLabel="Last Fee Collected"
              name="lastFeeCollected"
              onChange={(e) =>
                form.setValue("lastFeeCollected", e.target.value)
              }
            />
          </Grid2>
          <Grid2 size={4}>
            <GKTextField
              inputLabel="Partner"
              name="partner"
              onChange={(e) => form.setValue("partner", e.target.value)}
            />
          </Grid2>

          <Grid2 size={12} mt={2}>
            <Tabs
              variant="fullWidth"
              value={tab}
              onChange={(e, val) => setTab(val)}
            >
              <Tab label="Fee Plan & Metrics" disableRipple />
              <Tab label="Partner" disableRipple />
              <Tab label="Calculations" disableRipple />
              <Tab label="Invoices" disableRipple />
            </Tabs>
          </Grid2>
        </Grid2>
      </Card>
    </DashboardLayout>
  );
};

export default EditRevenuePortfolio;
